import { CARRIER } from '../../constants';
import { SELECT_CARRIER } from './carrierActions';

const InitialState = CARRIER.CARRIER_NOT_CHOSEN;

export default function carrierReducer(state = InitialState, action) {
    const {
        type,
        payload,
    } = action;

    switch (type) {
        case SELECT_CARRIER:
            return payload.carrierId;

        default:
            return state;
    }
}
